import { useQuery } from "@tanstack/react-query"
import { shopifyMetafieldDefinitionsQuery } from "modules/settings/lib/shopify/shopifyMetafieldDefinitionsQuery"
import { ShopifyMetafieldOwnerType } from "schema"

export const useShopifyMetafieldDefinitionsQuery = (ownerType: ShopifyMetafieldOwnerType | null) =>
  useQuery({
    ...shopifyMetafieldDefinitionsQuery(ownerType ?? "product"),
    enabled: ownerType !== null,
  })
